import { defineStore } from 'pinia'

import type { AssessmentEditorStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

/**
 * The assessment editor's working document and every mutation over it.
 *
 * Pure state: it makes no request, parses nothing, and imports nothing from `api/**`.
 * The page hook loads via the `show` hook, calls `loadTemplate`, and on save reads the payload,
 * calls the update hook, then `applySavedTemplate`.
 */
export const useAssessmentEditorStore = defineStore('assessment-editor', {
  state: (): AssessmentEditorStore => ({
    templateId: null,
    title: '',
    type: null,
    disciplineCode: null,
    grade: null,
    status: null,
    workingDocument: null,
    pristine: null,
    selectedScreenId: null,
    selectedActivityId: null,
    interactionDrafts: {},
    loading: false,
    saving: false,
  }),
  actions,
  getters,
})
